import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import utils from "../../utils/utils";
import axios from 'axios/dist/axios.min.js';
import "./style.less";

class PipelineButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      joined: false,
      isLogin: false,
      showBtn: false
    };
    this.loginInterval = null;
    this.isSubmiting = false;
  }

  componentDidMount() {
    const CookieUA = utils.getCookie('ua');
    const CookieU = utils.getCookie('u');
    Promise.all([CookieUA, CookieU]).then(result => {
      const isLogin = result && result[0] && result[1]
      this.setState({
        isLogin,
      });
      if (isLogin) {
        this.joindAct()
      } else {
        this.setState({
          showBtn: true
        })
      }
    });
  }

  // 查询是否登录
  queryIsLogin = () => {
    this.loginInterval && clearInterval(this.loginInterval);
    this.loginInterval = setInterval(() => {
      const { isLogin } = this.state;
      if (!isLogin) {
        const CookieUA = utils.getCookie('ua');
        const CookieU = utils.getCookie('u');
        Promise.all([CookieUA, CookieU]).then(result => {
          const isLogin = result && result[0] && result[1]
          this.setState({
            isLogin
          });
          if (isLogin) {
            this.joindAct()
          }
        })
      } else {
        this.loginInterval && clearInterval(this.loginInterval);
        this.loginInterval = null;
      }
    }, 1000);
  }

  login = () => {
    if (utils.isShihuo()) {
      // 未登陆，请先进行微信登陆
      window.Jockey.send("subscribe", {}, (publishData) => {
        if (publishData.type === "loginSuccess") {
          this.queryIsLogin();
        }
      });
      window.Jockey.send("action", {
        url: "shihuo://www.shihuo.cn?route=login",
      });
    }
  }

  joindAct = (isSubmit) => {
    axios({
      url: `//sh-gateway.shihuo.cn/v4/services/sh-gocashbackapi/account/join-activity`,
      method: isSubmit ? 'post' : 'get',
      withCredentials: true,
    }).then(res => {
      this.isSubmiting = false
      const { status, data, msg } = res.data;
      if (status === 0) {
        if (isSubmit) {
          utils.toast('参与成功')
        }
        this.setState({
          joined: data.is_join,
        })
      } else {
        utils.toast(msg || '参与失败')
      }
      if (!this.state.showBtn) {
        this.setState({
          showBtn: true
        })
      }
    }).catch(e => {
      this.isSubmiting = false
      if (!this.state.showBtn) {
        this.setState({
          showBtn: true
        })
      }
    })
  }

  joinClick = () => {
    utils.uploadTrack(this.props);
    if (!this.state.isLogin) {
      this.login();
      return;
    }
    if (!this.state.joined && !this.isSubmiting) {
      this.isSubmiting = true;
      this.joindAct(true);
    }
  }

  render() {
    const { baseConfig } = this.props.config;
    const { joined, showBtn } = this.state;
    return (
      <div
        className="pipeline-button"
        {...this.props['customAttributes']}
      >
        {
          baseConfig.type === '周末折扣活动' && showBtn &&
          <img
            className="discount-act-btn"
            width="100%"
            src={utils.formatImgUrl(joined ? baseConfig.successBtnImg : baseConfig.btnImg, this.props.webpSupport)}
            onClick={this.joinClick}
          />
        }
      </div>
    );
  }
}

PipelineButton.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineButton };
export default PipelineButton;



// WEBPACK FOOTER //
// ./components/pipeline-button/index.js